import { EM_DASH } from 'constants/ui';

import { ChannelsTestIds } from './Channels.testIds';

export const CHANNEL_FORM_ID = 'channel-form';

export const ADD_CHANNEL_TITLE = 'Add Channel';

export const EDIT_CHANNEL_TITLE = 'Edit Channel';

export const FormPrefix = {
  MAX_EXTENSION: 'maxExtensionPeriodDays',
  LOAN_TYPE: 'loanType',
  TERM: 'term',
  PRICE: 'price',
  PERMITTED: 'numberOfTimesPermitted',
  COST: 'cost',
  MIN_RATE: 'minimumRateImprovement',
  LLPA_TYPE: 'llpaType',
};

export const ChannelFormTab = {
  GENERAL: 'general',
  LOCK_DESK: 'lockDesk',
  REGISTRATION_PROCESS: 'registrationProcess',
  LOAN_EDITOR_SECTIONS: 'loanEditorSections',
};

export const IntakeMethod = {
  MISMO_ONLY: 'MismoOnly',
  MISMO_WITH_DOCUMENTS: 'MismoWithDocuments',
  MANUAL_ENTRY: 'ManualEntry',
};

export const AusRequirement = {
  OFF: 'Off',
  OPTIONAL: 'Optional',
  REQUIRED: 'Required',
};

export const AusCompletionRequirement = {
  RUN: 'Run',
  APPROVE: 'Approve',
  APPROVE_ELIGIBLE: 'ApproveEligible',
};

export const TerminalAction = {
  SUBMIT_TO_UNDERWRITING: 'SubmitToUnderwriting',
  DELIVER_TO_INVESTOR: 'DeliverToInvestor',
  PURCHASE_CLEARED: 'PurchaseCleared',
};

export const PathStep = {
  PRICING: 'Pricing',
  LOCK: 'Lock',
  AUS: 'Aus',
  CONDITIONS: 'Conditions',
  DISCLOSURES: 'Disclosures',
};

export const PATH_STEP_LABEL = {
  [PathStep.PRICING]: 'Pricing',
  [PathStep.LOCK]: 'Lock',
  [PathStep.AUS]: 'AUS / DU',
  [PathStep.CONDITIONS]: 'Conditions',
  [PathStep.DISCLOSURES]: 'Disclosure',
};

export const DEFAULT_PATH_STEP_ORDER = [
  PathStep.PRICING,
  PathStep.LOCK,
  PathStep.AUS,
  PathStep.CONDITIONS,
  PathStep.DISCLOSURES,
];

export const PATH_STEP_SWITCH_FIELDS = [
  {
    pathStep: PathStep.PRICING,
    field: 'pricingStepEnabled',
    testId: ChannelsTestIds.CHANNEL_FORM_PRICING_STEP_SWITCH,
  },
  {
    pathStep: PathStep.LOCK,
    field: 'lockStepEnabled',
    testId: ChannelsTestIds.CHANNEL_FORM_LOCK_STEP_SWITCH,
  },
  {
    pathStep: PathStep.CONDITIONS,
    field: 'conditionsStepEnabled',
    testId: ChannelsTestIds.CHANNEL_FORM_CONDITIONS_STEP_SWITCH,
  },
  {
    pathStep: PathStep.DISCLOSURES,
    field: 'disclosureStepEnabled',
    testId: ChannelsTestIds.CHANNEL_FORM_DISCLOSURE_STEP_SWITCH,
  },
];

export const LoanEditorSection = {
  BORROWER: 'Borrower',
  FINANCIALS: 'Financials',
  PRICING: 'Pricing',
  DOCUMENTS: 'Documents',
  CONDITIONS: 'Conditions',
};

export const SectionVisibility = {
  NORMAL: 'Normal',
  READ_ONLY: 'ReadOnly',
  HIDDEN: 'Hidden',
};

export const CHANNEL_FORM_TABS = [
  { label: 'General', value: ChannelFormTab.GENERAL },
  { label: 'Lock Desk', value: ChannelFormTab.LOCK_DESK },
  { label: 'Registration Process', value: ChannelFormTab.REGISTRATION_PROCESS },
  { label: 'Loan Editor Sections', value: ChannelFormTab.LOAN_EDITOR_SECTIONS },
];

export const INTAKE_METHOD_OPTIONS = [
  { value: IntakeMethod.MISMO_ONLY, label: 'MISMO only' },
  { value: IntakeMethod.MISMO_WITH_DOCUMENTS, label: 'MISMO + document package' },
  { value: IntakeMethod.MANUAL_ENTRY, label: 'Manual entry' },
];

export const TERMINAL_ACTION_OPTIONS = [
  { value: TerminalAction.SUBMIT_TO_UNDERWRITING, name: 'Submit to UW' },
  { value: TerminalAction.DELIVER_TO_INVESTOR, name: 'Deliver to Investor' },
  { value: TerminalAction.PURCHASE_CLEARED, name: 'Purchase Cleared' },
];

export const AUS_REQUIREMENT_BUTTONS = [
  { value: AusRequirement.OFF, label: 'Off' },
  { value: AusRequirement.OPTIONAL, label: 'Optional' },
  { value: AusRequirement.REQUIRED, label: 'Required' },
];

export const AUS_COMPLETION_BUTTONS = [
  { value: AusCompletionRequirement.RUN, label: 'Run' },
  { value: AusCompletionRequirement.APPROVE, label: 'Approve' },
  { value: AusCompletionRequirement.APPROVE_ELIGIBLE, label: 'Approve/Eligible' },
];

export const SECTION_VISIBILITY_BUTTONS = [
  { value: SectionVisibility.NORMAL, label: 'Normal' },
  { value: SectionVisibility.READ_ONLY, label: 'Read-only' },
  { value: SectionVisibility.HIDDEN, label: 'Hidden' },
];

export const LOAN_EDITOR_SECTIONS = [
  { value: LoanEditorSection.BORROWER, label: 'Borrower' },
  { value: LoanEditorSection.FINANCIALS, label: 'Financials (income / assets / liabilities)' },
  { value: LoanEditorSection.PRICING, label: 'Pricing' },
  { value: LoanEditorSection.DOCUMENTS, label: 'Documents' },
  { value: LoanEditorSection.CONDITIONS, label: 'Conditions' },
];

export const ChannelStatus = {
  LIVE: 'live',
  NO_SHEET: 'noSheet',
};

export const CHANNEL_STATUS_LABEL = {
  [ChannelStatus.LIVE]: 'Live',
  [ChannelStatus.NO_SHEET]: 'No sheet',
};

export const CHANNEL_STATUS_TONE = {
  [ChannelStatus.LIVE]: 'fern',
  [ChannelStatus.NO_SHEET]: 'amber',
};

export const LOCK_EXTENSIONS_NOT_SET = 'Not set';

export const CHANNEL_EMPTY_VALUE = EM_DASH;

export const SHARED_CHANNEL_HINT = 'Platform-wide channel. Its programs can be mapped, not edited.';

export const MAP_PROGRAMS_TITLE = 'Map programs';

export const CUSTOMIZED_CHANNEL_LABEL = 'Customized';

export const CUSTOMIZED_CHANNEL_HINT =
  'This company changed which shared programs the channel offers.';

export const CHANNELS_EMPTY_MESSAGE = 'No channels yet.';
